import React from 'react';

export const Mdjim = () => {
  
    const paragraphStyle = {
        width: '800px',
        paddingLeft: '350px',
        paddingRight: '350px',
    };

    const imageStyle = {
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '3px solid white',
    };

    return (
        <div>
            <h1>About Me - Md Jim</h1>


            <div>
                <p style={paragraphStyle}>

                Hello! This is my about me page. I just recently turned 22 in January and have the knee pain of a 60 year old. I was born and raised for the most part in Astoria Queens. I am ethnically bengali with
            both my parents being from Bangladesh. I was fortunate enough to be raised in a neighborhood where a Puerto Rican, a Greek, and a Haitian were all just an apartment door away - allowing me to interact
            with diverse groups of people early on. As I'd gone to a highschool centered around the IB diploma and it's role in pushing students into their communites, I had gained valuable experience from working
            at a library all four years of highschool. Additionally, working in food kitchens during the breaks had given me new perspectives on how I view peoples' ongoing situations which I still utilize to this
            day.
            
            During the first week of freshmen, I initially was a mechanical engineering major as I'd recently got into NASCAR at the time and most the engineers in my family were somewhere around that field. 
            However, I dispised how constrained I was by the formulas that had already been created - I'd felt I was indirectly foreced to work in between two asymptotes I could never cross. I wanted to create,
            but also wanted creativity, so I'd chosen computer science. Over the last four years I've found myself initally hating CSE250 to now having taken CSE431, CSE474, and a security class. I've to love
            making in general, algorithms but more specifically, streamlining algorithms to be more optimized. From forcing to way to move away from dijkstra and instead A* algorithm in our CSE442 project to 
            over the summer, making a mock dewey decimal system for a library, I've come to enjoy that aspect of CS. 
            
                I owe my entire personality to be able to meet new and different people to where I grew up. If I'd grown up 20 miles east in Manhasset Long Island, I cannot see myself going out of my way to
            learn new things. 
                </p>
            </div>

            <img
                src="image.png"
                alt="Jim"
                style={imageStyle}
            />

            <div>
            <p>
                Pictured above was where I've spent most my life in as it was was 2 blocks away from my middle school and just a Q69/100 bus away. Apparently it was featured on Gordan Ramsey's show in 2023
                at some point - which I am just finding out. Makes sense why so many people were there when I went over the winter break
            </p>
            </div>

        </div>
    );
};
